(function () {
  'use strict';

  var root = document.getElementById('smartoneplan-root');
  if (!root || root.dataset.smartoneplanReady !== 'true') return;

  var modal = root.querySelector('#smartoneplan-modal');
  var acceptButton = root.querySelector('[data-smartoneplan-accept]');
  var declineButton = root.querySelector('[data-smartoneplan-decline]');
  var coveredTitle = root.querySelector('[data-smartoneplan-covered-title]');
  var errorBox = root.querySelector('[data-smartoneplan-error]');
  var warrantyProductId = Number(root.dataset.smartoneplanWarrantyProductId || 0);
  var warrantyVariantId = Number(root.dataset.smartoneplanWarrantyVariantId || 0);
  var pendingOffer = null;
  var closingAfterAccept = false;

  if (!modal || !acceptButton || !declineButton || !warrantyProductId || !warrantyVariantId) return;

  function localeRoot() {
    return window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
  }

  function productMetadataFromEvent(event) {
    var form = event.target && event.target.closest ? event.target.closest('form') : null;
    var productForm = form && form.closest ? form.closest('product-form') : null;
    var annotatedProduct = productForm
      ? productForm.querySelector('[data-smartoneplan-product="true"]')
      : null;
    var currentProduct = root.querySelector('[data-smartoneplan-product="true"]');
    var source = annotatedProduct || currentProduct;

    if (!source) return null;

    return {
      eligible: source.dataset.smartoneplanEligible === 'true',
      productId: Number(source.dataset.smartoneplanProductId || 0),
      handle: source.dataset.smartoneplanProductHandle || '',
      title: source.dataset.smartoneplanProductTitle || ''
    };
  }

  function matchingAddedItem(items, productId) {
    if (!Array.isArray(items) || !items.length) return null;
    return items.find(function (item) {
      return Number(item.product_id) === Number(productId);
    }) || items[0];
  }

  function alreadyProtected(cart, coveredLineKey) {
    if (!cart || !Array.isArray(cart.items) || !coveredLineKey) return false;

    return cart.items.some(function (item) {
      var properties = item.properties || {};
      return Number(item.product_id) === warrantyProductId && properties._protected_line_key === coveredLineKey;
    });
  }

  function drawerElement() {
    return document.querySelector('cart-drawer');
  }

  function waitForDrawerRefresh(timeout) {
    var drawer = drawerElement();
    if (!drawer) return Promise.resolve();

    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(done, timeout || 1500);

      function done() {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        drawer.removeEventListener('cart-drawer:refreshed', done);
        resolve();
      }

      drawer.addEventListener('cart-drawer:refreshed', done, { once: true });
    });
  }

  async function showDrawerWhenReady(refreshPromise) {
    if (refreshPromise) await refreshPromise;
    var drawer = drawerElement();
    if (drawer && typeof drawer.show === 'function') await drawer.show();
  }

  function resetError() {
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  function setBusy(isBusy) {
    acceptButton.disabled = isBusy;
    declineButton.disabled = isBusy;
    acceptButton.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function openOffer(offer) {
    pendingOffer = offer;
    closingAfterAccept = false;
    resetError();
    setBusy(false);
    coveredTitle.textContent = offer.item.product_title || offer.metadata.title || 'this item';

    if (typeof modal.show === 'function') modal.show();
    else modal.setAttribute('open', '');
  }

  document.addEventListener('variant:add', function (event) {
    var metadata = productMetadataFromEvent(event);
    if (!metadata || !metadata.eligible || metadata.productId === warrantyProductId) return;

    var item = matchingAddedItem(event.detail && event.detail.items, metadata.productId);
    var cart = event.detail && event.detail.cart;
    if (!item || Number(item.product_id) === warrantyProductId) return;
    if (alreadyProtected(cart, item.key)) return;

    openOffer({
      metadata: metadata,
      item: item,
      drawerRefreshPromise: null,
      cartChangeConsumed: false
    });
  });

  document.documentElement.addEventListener('cart:change', function (event) {
    if (!pendingOffer || pendingOffer.cartChangeConsumed) return;
    if (!event.detail || event.detail.baseEvent !== 'variant:add') return;

    pendingOffer.cartChangeConsumed = true;
    pendingOffer.drawerRefreshPromise = waitForDrawerRefresh(1800);

    // The drawer still receives and renders the new cart HTML, but it does not
    // open behind the protection modal. This is the only theme behavior that
    // currently checks baseEvent in Prestige 10.11.1.
    event.detail.baseEvent = 'smartoneplan:offer';
  });

  async function addWarranty() {
    if (!pendingOffer) return;

    setBusy(true);
    resetError();

    try {
      var sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));

      sections = sections.filter(function (sectionId, index, all) {
        return sectionId && all.indexOf(sectionId) === index;
      });

      var body = new FormData();
      body.set('id', String(warrantyVariantId));
      body.set('quantity', '1');
      body.set('properties[Protection for]', pendingOffer.item.product_title || pendingOffer.metadata.title || 'Furniture item');
      body.set('properties[_protected_product_id]', String(pendingOffer.item.product_id || pendingOffer.metadata.productId));
      body.set('properties[_protected_variant_id]', String(pendingOffer.item.variant_id || pendingOffer.item.id || ''));
      body.set('properties[_protected_line_key]', pendingOffer.item.key || '');
      body.set('sections', sections.join(','));
      body.set('sections_url', window.location.pathname + window.location.search);

      var response = await fetch(localeRoot() + 'cart/add.js', {
        method: 'POST',
        body: body,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || 'Protection could not be added. Please try again.');
      }

      var cartResponse = await fetch(localeRoot() + 'cart.js');
      if (!cartResponse.ok) throw new Error('The cart could not be refreshed. Please try again.');

      var cart = await cartResponse.json();
      cart.sections = responseJson.sections || {};

      var drawerRefreshPromise = waitForDrawerRefresh(1800);
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'smartoneplan:add',
          cart: cart
        }
      }));

      closingAfterAccept = true;
      if (typeof modal.hide === 'function') await modal.hide();
      else modal.removeAttribute('open');

      pendingOffer = null;
      closingAfterAccept = false;
      await showDrawerWhenReady(drawerRefreshPromise);
    } catch (error) {
      errorBox.textContent = error && error.message
        ? error.message
        : 'Protection could not be added. Please try again.';
      errorBox.hidden = false;
      setBusy(false);
    }
  }

  acceptButton.addEventListener('click', addWarranty);
  declineButton.addEventListener('click', function () {
    if (typeof modal.hide === 'function') modal.hide();
    else modal.removeAttribute('open');
  });

  modal.addEventListener('dialog:after-hide', function () {
    if (!pendingOffer || closingAfterAccept) return;

    var refreshPromise = pendingOffer.drawerRefreshPromise;
    pendingOffer = null;
    showDrawerWhenReady(refreshPromise);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    pendingOffer = null;
    closingAfterAccept = false;
    resetError();
    setBusy(false);
  });
})();
